var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9276 6.66699H0.748047V31.0416H25.9276V6.66699Z",
    stroke: "#29ABE2",
    strokeWidth: 1.06247,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3853 17.7979H0.281494V19.9131H26.3853V17.7979Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.0332023,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3173 6.23535H12.1064V31.4998H14.3173V6.23535Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.0332023,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0507 5.20673C12.1833 3.88722 11.0634 2.75164 9.75465 1.86767C9.45906 1.66774 9.12534 1.47397 8.76886 1.50288C8.23152 1.54594 7.86304 2.07713 7.71848 2.59632C7.26972 4.1865 8.19461 5.8385 9.78479 6.28725C10.352 6.4475 10.9536 6.43674 11.5137 6.25619C12.4792 5.94861 13.2198 5.17936 13.8657 4.39934C14.5116 3.61932 15.128 2.78056 15.9846 2.24568C16.8412 1.7108 18.0282 1.53487 18.8405 2.14049C19.7116 2.79132 19.8192 4.1745 19.2161 5.0754C18.6129 5.97629 17.4693 6.42136 16.3817 6.39152C15.2941 6.36169 13.8177 6.37491 13.051 5.20704L13.0507 5.20673Z",
    stroke: "#F39200",
    strokeWidth: 1.66011,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5385 5.70996C11.8483 8.74883 9.31659 11.0231 6.22144 11.3857",
    stroke: "#F39200",
    strokeWidth: 1.66011,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2749 5.44629C14.1004 7.12843 14.9967 8.83703 16.4202 10.0547C17.844 11.2727 19.9281 11.8996 21.6318 11.1208",
    stroke: "#F39200",
    strokeWidth: 1.66011,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentIcon);
export default __webpack_public_path__ + "static/media/presentIcon.7ef1708e47deb86269539fcc519e210d.svg";
export { ForwardRef as ReactComponent };